import React, { useContext, useEffect, useState } from "react";
import { Col, Button, Image, Form, Row, Spinner } from "react-bootstrap";
import momentJs from "react-day-picker/moment";
import LodgingItineraryUnit from "../../../../../../Data/Reservation/Lodging/LodgingItineraryUnit";
import { Modifier } from "react-day-picker";
import { DatesAndGuests } from "../../../widget-form/WidgetForm";
import VendorUnit from "../../../../../../Data/VendorUnit";
import { WidgetContext } from "../../../../../../context/WidgetContext";
import ProductRate from "../../../../../../Data/Rates/ProductRate";
import Decimal from "decimal.js";
import LodgingItem from "../../../../../../Data/LodgingItem";
import moment from "moment";
import Itinerary from "../../../../../../Data/Itinerary";
import { getAvailableVendorUnits, getVendorUnitIdFromUnitName, getUnitNameFromVendorUnitId, getVendorUnitIdsFromSelectedName } from "../../../../../../Data/Rates/UnitRateLogic";
import { roundDecimal, isStringEmpty } from "../../../../../../_helpers/Functions";
import CustomDayPickerInput from "../../../../customDayPickerInput/CustomDayPickerInput";
import MobileUnitTabDetails from "../components/MobileUnitTabDetails";
import UseGetLodgingVendors, { GetLodgingVendorsRequest } from "../../widget-modals/lodging/add-lodging/data-service-hooks/UseGetLodgingVendors";

interface props {
  itinerary: Itinerary;
  item: LodgingItineraryUnit;
  vendor: LodgingItem,
  itemIndex: number;
  datesAndGuests: DatesAndGuests;
  removeItem: (unit: LodgingItineraryUnit) => void;
  editItem: (unit: LodgingItineraryUnit) => void;
  bookNowRequested: boolean;
  quoteRequested: boolean;
  quoteStatus: number | undefined;
  onVendorImageClick: (vendor: LodgingItem) => void;
  editable: boolean;
  onCheckInDateChanged: (date: string) => void;
  onCheckOutDateChanged: (date: string) => void;
}

const LodgingTab: React.FC<props> = (props) => {
  const { startWidget, style, fromEmail, viewPortBreakPoint, brandSettings, /* brandId */ brand } = useContext(WidgetContext);
  const { itinerary, item, itemIndex, datesAndGuests, removeItem, editItem, quoteRequested, bookNowRequested, quoteStatus } = props;

  const brandSetting = brandSettings.find((s: any) => s.brandId === brand?.brandId);

  const [vendor, setVendor] = useState<LodgingItem>(props.vendor);
  const [vendorUnits, setVendorUnits] = useState<VendorUnit[]>([]);
  const rates = vendor && vendor.dailyRates ? vendor.dailyRates : [];

  const { formatDate, parseDate } = momentJs;
  const [checkIn, setCheckIn] = useState<Date>(moment(item.startDate).toDate());
  const [checkOut, setCheckOut] = useState<Date>(moment(item.endDate).toDate());
  const modifiers = { start: checkIn, end: checkOut };

  const [guests, setGuests] = useState(item.numberOfGuests);
  const [numberOfUnits, setNumberOfUnits] = useState(item.numberOfUnits);

  const [unavailableMessage, setUnavailableMessage] = useState<string | undefined>();

  const [selectedUnit, setSelectedUnit] = useState<number | null>(null);
  // const [selectedUnitName, setSelectedUnitName] = useState<string | null>(getUnitNameFromVendorUnitId(rates, item.vendorUnitId));
  const [selectedUnitName, setSelectedUnitName] = useState<string | null>(item.unitName);
  const [selectedTravePortUnitName, setSelectedTravePortUnitName] = useState<string | null>(vendor.travelPortRateName || item.travelPortRateName);
  const [productRate, setProductRate] = useState<ProductRate>();

  const [unitRateTotal, setUnitRateTotal] = useState(0);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [getLodgingVendorsRequest, setGetLodgingVendorsRequest] = useState<GetLodgingVendorsRequest>();
  const responseGetLodgingVendors = UseGetLodgingVendors(getLodgingVendorsRequest);

  const [errorsImg, setErrorsImg] = useState<string | undefined>();
  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";
  const vendorImageUrl = errorsImg ? errorsImg : (vendor.description ?
    (vendor.description.vendorDescriptionImages.length > 0 ?
      ((vendor.description.vendorDescriptionImages[0].vendorImageUrl != undefined && vendor.description.vendorDescriptionImages[0].vendorImageUrl.length > 0) ? vendor.description.vendorDescriptionImages[0].vendorImageUrl
        : placeholderImgUrl)
      : placeholderImgUrl)
    : placeholderImgUrl);

  const checkInDateChanged = (date: Date) => {
    const cin = moment(date).hours(0).format("YYYY-MM-DD");
    const cout = moment(date).hours(0).format("YYYY-MM-DD");
    props.onCheckInDateChanged(cin);
    setCheckIn(moment(cin).toDate());
    if (moment(cin).isAfter(cout)) {
      setCheckOut(moment(cin).toDate());
      props.onCheckOutDateChanged(cout);
    }
  }

  const checkOutDateChanged = (date: Date) => {
    const checkOut = moment(date).hours(0).format("YYYY-MM-DD");
    props.onCheckOutDateChanged(checkOut);
    setCheckOut(moment(date, "YYYY-MM-DD").hours(0).toDate());
  }

  const onGuestsInputChanged = (event: any) => {
    setGuests(+event.target.value);
    if (numberOfUnits > +event.target.value)
      setNumberOfUnits(1);
  };

  const onUnitsInputChanged = (event: any) => {
    setNumberOfUnits(+event.target.value);
  };

  // const unitOptions = vendorUnits.map((unit: VendorUnit, index: number) => (
  //   <option value={unit.uniqueIdForSelection} key={index}>{unit.unitName}</option>
  // ));

  const unitOptions = vendorUnits.filter(u => !props.editable || u.published).map((unit: VendorUnit, index: number) => (
    <option value={unit.uniqueIdForSelection} key={index}>{unit.unitName}</option>
  ));

  function getNumGuestsOptions(): JSX.Element[] {
    const options: JSX.Element[] = [];
    const maxGuests = item.numberOfGuests;

    for (let index = 0; index < maxGuests; index++) {
      options.push(<option key={`lodging ${itemIndex} unit option ${index}`}>{index + 1}</option>);
    }

    return options;
  }

  function getNumUnitsOptions(): JSX.Element[] {
    const options: JSX.Element[] = [];

    // for (let index = 0; index < item.preBuiltPkgVendorUnit !== undefined ? item.preBuiltPkgVendorUnit.toUnits : guests; index++) {
    for (let index = 0; index < guests; index++) {
      options.push(<option key={`lodging ${itemIndex} guests option ${index}`}>{index + 1}</option>);
    }

    return options;
  }

  function getPriceString() {
    if (brandSetting && brandSetting.usePkgPriceByLodging && itinerary.lodgingItineraries && itinerary.lodgingItineraries[0].itineraryUnits.length >= brandSetting.usePkgPriceByLodgingNumber) return "Package Price";
    return "$" + (fromEmail ? item.sell.toFixed(2) : (unitRateTotal).toFixed(2));
  }

  useEffect(() => {
    setVendor(props.vendor);
    setGetLodgingVendorsRequest({ brandId: brand?.brandId as number, startDate: moment(checkIn).format('YYYY-MM-DD'), endDate: moment(checkOut).format('YYYY-MM-DD'), vendorId: vendor.vendorId, guests: guests, units: numberOfUnits });
  }, [props.vendor]);

  useEffect(() => {
    if (!vendor) return;

    const _vendorUnits = getAvailableVendorUnits(props.vendor.vendorUnits, rates, moment(checkIn).format("MM/DD/YYYY"), moment(checkOut).format("MM/DD/YYYY"));
    _vendorUnits.sort((a, b) => {
      if (a.sortOrder < b.sortOrder) return -1;
      if (a.sortOrder > b.sortOrder) return 1;

      if (a.unitName.toLowerCase() < b.unitName.toLowerCase()) return -1;
      if (a.unitName.toLowerCase() > b.unitName.toLowerCase()) return 1;

      return 0;
    });
    setVendorUnits(_vendorUnits);
    // console.log("_vendorUnits", _vendorUnits);
    // console.log("selectedUnitName", selectedUnitName);

    if (_vendorUnits.findIndex(a => a.uniqueIdForSelection === selectedUnitName) < 0 && props.quoteStatus !== 30) {
      if (_vendorUnits.length > 0) {
        // console.log("set selected unit name");
        setSelectedUnitName(_vendorUnits[0].uniqueIdForSelection);
      }
    }

    let nights: Date[] = [];
    let night = moment(checkIn, 'YYYY-MM-DD');
    const checkOutDate = moment(checkOut, 'YYYY-MM-DD');
    while (night.isBefore(checkOutDate)) {
      nights.push(night.toDate());
      night = night.clone().add(1, 'day');
    }

    if (nights.length === 0)
      setUnavailableMessage("Invalid date range");
    else setUnavailableMessage("");
  }, [vendor, checkIn, checkOut]);

  useEffect(() => {
    setUnitRateTotal(0);

    const dayRates = rates.filter(a => a.unitRates.findIndex(b => b.vendorUnitDisplayName === selectedUnitName) >= 0);

    const nights: Date[] = [];
    let night = moment(checkIn, "YYYY-MM-DD");
    const checkOutDate = moment(checkOut, "YYYY-MM-DD");
    while (night.isBefore(checkOutDate)) {
      nights.push(night.toDate());
      night = night.clone().add(1, "day");
    }

    const unavailableDates = nights.filter(night => !dayRates.find(rate => {
      return moment(rate.date).format("MM/DD/YYYY").toString() === moment(night).format("MM/DD/YYYY").toString();
    }));

    if (unavailableDates.length) {
      let unavailableDatesMessage = "";
      unavailableDates.forEach(date => {
        unavailableDatesMessage += ` ${moment(date).format("MM/DD/YYYY")} no rates available.`;
      });
      setUnavailableMessage(unavailableDatesMessage);
      return;
    }

    const ratesForNights = dayRates.filter(rate => nights.find(night => moment(night).format("MM/DD/YYYY").toString() === moment(rate.date).format("MM/DD/YYYY").toString()));
    const ratesForUnitName = ratesForNights.flatMap(a => a.unitRates).filter(a => a.vendorUnitDisplayName === selectedUnitName);

    // setRatesForDates(ratesForNights.flatMap(a => a.rates));
    const unavailableRates = ratesForUnitName.filter(rate => rate.unavailable);
    if (!unavailableRates.length) {
      setUnavailableMessage("");
    } else {
      let message = "";
      unavailableRates.forEach(date => {
        message += ` ${moment(date.date).format("MM/DD/YYYY")} ${date.unavailableMessage}`;
      });

      setUnavailableMessage(message);
    }

    if (ratesForUnitName.length > 0) {
      setSelectedUnit(ratesForUnitName[0].vendorUnitId);
    }

    // let rate = ratesForUnitName.flatMap(a => a.rates).reduce((a, b) => a.add(new Decimal(b ? b.price : 0)), new Decimal(0)).times(units);
    let rate: any = null;
    const innerRates = ratesForUnitName.flatMap((a: any) => a.rates);
    let testRate: any = undefined;

    if (!innerRates.some((r: any) => r.isLive))
      rate = innerRates.reduce((a: any, b: any) => a.add(new Decimal(b?.price || 0)), new Decimal(0)).times(numberOfUnits);
    else {
      const test = innerRates.filter((r: any) => r.travelPortRateName == selectedTravePortUnitName);
      if (test.length > 0) {
        rate = test.reduce((a: any, b: any) => a.add(new Decimal(b?.price || 0)), new Decimal(0)).times(numberOfUnits);
        testRate = test[0];
      }

      // rate = innerRates.reduce((a: any, b: any) => a.add(new Decimal(b?.price || 0)), new Decimal(0)).times(numberOfUnits);

    }
    // if (props.vendor.fees !== undefined && props.vendor.fees.cleaningFeePerDayOrPerUnit === "Unit") {
    //   rate = rate.add(props.vendor.fees.cleaningFee * units);
    // }
    if (rate !== null) {
      setUnitRateTotal(roundDecimal(rate).toNumber());
      if (testRate !== undefined)
        setProductRate(testRate);
    }

    if (nights.length === 0)
      setUnavailableMessage("Invalid date range");

  }, [checkIn, checkOut, selectedUnitName, numberOfUnits, selectedTravePortUnitName, vendor]);

  useEffect(() => {
    if (quoteRequested || bookNowRequested) {
      item.startDate = moment(checkIn).format("YYYY-MM-DD");
      item.endDate = moment(checkOut).format("YYYY-MM-DD");
      item.numberOfGuests = guests;
      item.numberOfUnits = numberOfUnits;
      item.vendorUnitId = getVendorUnitIdFromUnitName(vendor.dailyRates, selectedUnitName);;

      item.sell = moment(item.startDate).isSame(item.endDate) ? -1 : unitRateTotal;
      item.isValid = isStringEmpty(unavailableMessage);
      item.travelPortRateName = selectedTravePortUnitName;
      item.productRateId = productRate !== undefined ? productRate.productRateId : 0;
    }
  }, [quoteRequested, bookNowRequested]);

  useEffect(() => {
    setCheckIn(moment(item.startDate).toDate());
    setCheckOut(moment(item.endDate).toDate());
  }, [props.item]);

  useEffect(() => {
    if (responseGetLodgingVendors.data) {
      const responseData = responseGetLodgingVendors.data;

      if (responseData.length > 0) {
        setVendor({ ...responseData[0] });
      }
      setIsLoading(false);
    }
  }, [responseGetLodgingVendors.data]);

  return (
    <React.Fragment>
      {/* Lodging Items */}
      {/* Desktop */}

      {item.showOnItinerary && (
        <>
          <Row className="d-none d-md-flex flex-row item-container">
            {/* Container for Lodging Items */}

            {/* Image */}
            <Col
              xs={3}
              className="d-flex flex-row justify-content-start image-col"
            >
              <Image
                style={{ padding: "0" }}
                className="d-flex item-image-desktop"
                src={vendorImageUrl}
                onClick={() => {
                  props.onVendorImageClick(props.vendor)
                }}
                fluid
              />
            </Col>

            {/* Form */}
            <Col xs={10} className="d-flex flex-column pl-3" style={{ maxWidth: 'calc(100% - 250px)' }}>
              <Row>
                {/* <Col> */}
                <h5
                  className="form-header itinerary-font"
                  style={{ color: style.fontColor }}
                >
                  {vendor ? vendor.vendorName : ""}
                </h5>
                <p
                  className="itinerary-font ml-3 mt-3"
                  style={{ color: style.fontColor }}
                >
                  {vendor ? vendor.city : ""}, {vendor ? vendor.state : ""}
                </p>
                {/* </Col> */}
              </Row>

              {/* DatePickers */}
              <div className="d-flex flex-row">
                <Col xs={4} className="d-flex flex-column InputFromTo p-0 pr-1">
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Arrive
                  </Form.Label>
                  <CustomDayPickerInput
                    // overlayComponent={MobileDayPickerOverlay}
                    inputProps={{ readOnly: fromEmail || !props.editable, disabled: !props.editable || quoteStatus !== undefined, style: { color: style.fontColor } }}
                    value={moment(checkIn).format("ddd, MMM Do, YYYY")}
                    placeholder="From"
                    format="LL"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={{
                      selectedDays: { from: checkIn, to: checkOut } as Modifier,
                      disabledDays: { before: moment(datesAndGuests.fromDate).toDate(), after: moment(datesAndGuests.toDate).toDate() },
                      numberOfMonths: 1,
                      month: datesAndGuests.fromDate,
                      modifiers
                    }}
                    onDayChange={checkInDateChanged}
                  />
                </Col>

                <Col xs={4} className="d-flex flex-column InputFromTo p-0 pl-1">
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Depart
                  </Form.Label>
                  <CustomDayPickerInput
                    // overlayComponent={MobileDayPickerOverlay}
                    inputProps={{ readOnly: fromEmail || !props.editable, disabled: !props.editable || quoteStatus !== undefined, style: { color: style.fontColor } }}
                    value={moment(checkOut).format("ddd, MMM Do, YYYY")}
                    placeholder="Check Out"
                    format="LL"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={{
                      selectedDays: { from: checkIn, to: checkOut } as Modifier,
                      disabledDays: { before: moment(checkIn).toDate(), after: moment(datesAndGuests.toDate).toDate() },
                      numberOfMonths: 1,
                      month: datesAndGuests.fromDate,
                      modifiers
                    }}
                    onDayChange={checkOutDateChanged}
                  />

                  {/* {unavailableMessage && (
                    <Row className="m-0 p-0 my-2">
                      <p className="m-0 p-0 font-italic text-danger">{unavailableMessage}</p>
                    </Row>
                  )} */}
                </Col>

                <div className="d-flex flex-column small-select ml-2">
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Guests
                  </Form.Label>
                  <Form.Control
                    style={{ color: style.fontColor, fontSize: 14 }}
                    as="select"
                    className="itinerary-font guest-select"
                    name="guests"
                    defaultValue={item.numberOfGuests.toString()}
                    onChange={onGuestsInputChanged}
                    readOnly={!props.editable || quoteStatus !== undefined}
                    disabled={!props.editable || quoteStatus !== undefined}
                  >
                    {getNumGuestsOptions()}
                  </Form.Control>
                </div>

                <div className="d-flex flex-column ml-2">
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Units
                  </Form.Label>
                  <Form.Control
                    style={{ color: style.fontColor, fontSize: 14 }}
                    as="select"
                    className="itinerary-font guest-select"
                    name="units"
                    defaultValue={item.numberOfUnits.toString()}
                    onChange={onUnitsInputChanged}
                    readOnly={!props.editable || quoteStatus !== undefined}
                    disabled={!props.editable || quoteStatus !== undefined}
                  >
                    {getNumUnitsOptions()}
                  </Form.Control>
                </div>

                {!isLoading && (
                  <Col xs={2} className="d-flex flex-column m-0 p-0 mr-0 ml-3" style={{ justifyContent: 'flex-end' }}>
                    {props.quoteStatus !== 40 && props.quoteStatus !== 50 && (props.quoteStatus !== 10 || !!!unavailableMessage) && (
                      <div className="add-buttons">
                        <p className="m-0 p-0 text-right font-weight-bold green-text">{!vendor.rateDisplayOption.showPkgPriceOnly && startWidget.showLodgingPricing ? getPriceString() : "Package Price"}</p>
                      </div>
                    )}
                    {(props.quoteStatus === 40 || props.quoteStatus === 50) && (
                      <div className="add-buttons">
                        <p className="m-0 p-0 text-right red-text font-italic">{"Cancelled"}</p>
                      </div>
                    )}
                    {(quoteStatus === undefined || props.quoteStatus === 10) && unavailableMessage && (
                      <div className="add-buttons">
                        <p className="m-0 p-0 red-text text-right font-italic">{unavailableMessage}</p>
                      </div>
                    )}
                  </Col>
                )}
              </div>



              {/* Selects */}
              {!isLoading && (
                <div className="d-flex flex-row" style={{ marginTop: "10px" }}>
                  {!vendorUnits.find(u => u.uniqueIdForSelection === selectedUnitName)?.isLive && (
                    <>
                      {props.quoteStatus !== undefined && (
                        <Col xs={6} lg={8} className="d-flex flex-column">
                          <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                            Unit Type
                          </Form.Label>
                          <Form.Control
                            type="text"
                            disabled={item.preBuiltPkgVendorUnit !== undefined || !props.editable || quoteStatus !== undefined}
                            readOnly={item.preBuiltPkgVendorUnit !== undefined || !props.editable || quoteStatus !== undefined}
                            value={item.unitName}
                          >
                          </Form.Control>
                        </Col>
                      )}

                      {props.quoteStatus === undefined && (
                        <Col xs={6} lg={8} className="d-flex flex-column">
                          <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                            Unit Type
                          </Form.Label>
                          <Form.Control
                            hidden={vendorUnits.find(u => u.uniqueIdForSelection === selectedUnitName) === undefined || vendorUnits.find(u => u.uniqueIdForSelection === selectedUnitName)?.isLive}
                            style={{ color: style.fontColor }}
                            as="select"
                            className=""
                            disabled={item.preBuiltPkgVendorUnit !== undefined || !props.editable || quoteStatus !== undefined}
                            readOnly={item.preBuiltPkgVendorUnit !== undefined || !props.editable || quoteStatus !== undefined}
                            value={selectedUnitName || undefined}
                            onChange={(event: any) => {
                              setSelectedUnitName(event.currentTarget.value)
                            }} >
                            <option value="" disabled hidden>Select a unit</option>
                            {unitOptions}
                          </Form.Control>
                        </Col>
                      )}
                    </>
                  )}

                  {vendorUnits.find(u => u.uniqueIdForSelection === selectedUnitName)?.isLive && (
                    <Form.Group as={Col} xs={6} lg={8} controlId="vendorUnit">
                      <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                        Unit Type
                    </Form.Label>
                      <Form.Control as="select"
                        style={{ color: style.fontColor }}
                        name="vendorUnit"
                        value={selectedTravePortUnitName || undefined}
                        disabled={!props.editable || quoteStatus !== undefined}
                        readOnly={!props.editable || quoteStatus !== undefined}
                        onChange={(event: any) => {
                          const value = event.currentTarget.value;
                          setSelectedTravePortUnitName(event.currentTarget.value);
                        }} >
                        <option value="" hidden>Select a unit</option>
                        {/* {liveUnitOptions} */}
                        {vendorUnits.find(u => u.uniqueIdForSelection === selectedUnitName)?.rates.map(u => (<option>{u.travelPortRateName}</option>))}
                      </Form.Control>
                    </Form.Group>
                  )}

                  {(quoteStatus == 20 || quoteStatus == 30 || quoteStatus == 60) && (
                    <Col xs={4} className="d-flex flex-column m-0 p-0 pr-2 mr-0 ml-2">
                      <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                        Confirmation #
                    </Form.Label>
                      <Form.Control
                        className="font-italic"
                        style={{ color: item.confirmationNumber ? "green" : "red" }}
                        type="text"
                        value={item.confirmationNumber ? item.confirmationNumber : "Pending Confirmation"}
                        readOnly={true}
                        disabled={true}
                      >
                      </Form.Control>
                    </Col>
                  )}

                  {(quoteStatus == 40 || quoteStatus == 50) && (
                    <Col xs={4} className="d-flex flex-column m-0 p-0 mr-0 ml-2">
                      <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                        Cancellation #
                    </Form.Label>
                      <Form.Control
                        className="font-italic"
                        style={{ color: item.cancellationNumber ? "green" : "red" }}
                        type="text"
                        value={item.cancellationNumber ? item.cancellationNumber : "Pending Cancellation"}
                        readOnly={true}
                        disabled={true}
                      >
                      </Form.Control>
                    </Col>
                  )}

                  {quoteStatus === undefined && props.editable && (
                    <Col
                      className={"d-flex flex-column justify-content-end"}
                    >
                      <Button
                        size="sm"
                        style={{
                          backgroundColor: "#C50505",
                          border: "none",
                          height: "30px",
                          width: 'auto',
                          alignSelf: 'self-end'
                        }}
                        onClick={() => {
                          removeItem(item);
                        }}
                      >
                        Remove
                      </Button>
                    </Col>
                  )}
                </div>
              )}

              {isLoading && (
                <span className="mt-2"><Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                /> Loading...</span>
              )}
            </Col>
          </Row>

          {/* Mobile  */}
          <MobileUnitTabDetails
            vendor={vendor}
            showPricing={startWidget.showLodgingPricing}
            editable={props.editable}
            getPriceString={getPriceString}
            editItem={editItem}
            removeItem={removeItem}
            item={item}
            quoteStatus={quoteStatus}
          >
            <h6 style={{ color: style.fontColor, fontSize: 14 }} className="mobile-item-header">
              {vendor ? vendor.vendorName : ""}
              {/* {true && (<span className="red-text font-italic"> - Cancelled</span>)} */}
            </h6>
            <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{moment(item.startDate).format("MMM Do, YYYY")} - {moment(item.endDate).format("MMM Do, YYYY")}</p>
            <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{item.numberOfGuests} Guest{item.numberOfGuests == 1 ? "" : "s"}</p>
            <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{item.numberOfUnits ? item.numberOfUnits : 1} Unit{item.numberOfUnits && item.numberOfUnits != 1 ? "s" : ""}
              <span style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">&nbsp;{selectedUnitName}</span>
            </p>
          </MobileUnitTabDetails>
        </>
      )}
    </React.Fragment>
  );
}

export default LodgingTab;